import { api } from '../api'

const API = 'Panels'

const ENDPOINTS = {
  GET_CUSTOMER_BUSINESS_HISTORY: `${API}/GetAllCustomerBusinessHistory`
}

class ModuleService {
  async getCompanyBusinessHistory ({ customerCompanyID }) {
    return api.get(ENDPOINTS.GET_CUSTOMER_BUSINESS_HISTORY, {
      params: {
        filter: `customerID=="${customerCompanyID}"`
      }
    })
  }
}

export const ServicePanels = new ModuleService()
